import { render, staticRenderFns } from "./AgendaWeekComponent.vue?vue&type=template&id=7e967d9e&scoped=true"
import script from "./AgendaWeekComponent.vue?vue&type=script&lang=js"
export * from "./AgendaWeekComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaWeekComponent.vue?vue&type=style&index=0&id=7e967d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e967d9e",
  null
  
)

export default component.exports